// @ts-nocheck
import { PERMISSIONS_GROUPS_DRAWER_CHANGED, PERMISSIONS_GROUP_RECEIVED } from '../types';

const initialState = {
    current: null,
    drawer: {
        type: '',
        isVisible: false,
    },
};

const permissionsGroups = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case PERMISSIONS_GROUP_RECEIVED: {
            return {
                ...state,
                current: payload,
            };
        }
        case PERMISSIONS_GROUPS_DRAWER_CHANGED: {
            return {
                ...state,
                drawer: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default permissionsGroups;
